module.exports = __webpack_public_path__ + "static/media/commercial_property.a2a486f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/commercial_property.svg
// module id = 1420
// module chunks = 0